import { useState } from "react";
import Cropper from "react-easy-crop";
import { ZoomIn } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";

const round = (v) => Math.round(v * 1000) / 1000;

// target: {src, aspect, crop, label} | null
export const CropDialog = ({ target, onClose, onSave }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);
  if (!target) return null;
  const save = () => (area ? onSave({ x: round(area.x), y: round(area.y), width: round(area.width), height: round(area.height) }) : onClose());
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl rounded-none" data-testid="crop-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-black uppercase">Crop · {target.label}</DialogTitle>
          <DialogDescription>Drag to choose the area to keep and use the slider to zoom.</DialogDescription>
        </DialogHeader>
        <div className="relative h-[50vh] min-h-[260px] bg-slate-900">
          <Cropper image={target.src} crop={crop} zoom={zoom} minZoom={1} maxZoom={5} aspect={target.aspect}
            onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={(a) => setArea(a)}
            initialCroppedAreaPercentages={target.crop || undefined} />
        </div>
        <div className="flex items-center gap-3">
          <ZoomIn className="h-4 w-4 text-slate-500" />
          <input type="range" min={1} max={5} step={0.01} value={zoom} onChange={(e) => setZoom(Number(e.target.value))}
            className="flex-1 accent-lime-500" data-testid="crop-zoom-slider" aria-label="Crop zoom" />
        </div>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} data-testid="crop-cancel-button" className="border-2 border-slate-200 px-4 py-2 text-sm font-bold hover:border-slate-900">Cancel</button>
          <button type="button" onClick={save} data-testid="crop-save-button" className="btn-blaze px-5 py-2 text-sm">Apply crop</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
